import { Link } from 'react-router-dom';
import { FiChevronLeft } from 'react-icons/fi';

/**
 * The session view's top navigation: a mobile header (back button + title +
 * options menu) or a desktop breadcrumb row (Sites › {site} › Test + options
 * menu). The options menu element is supplied by the caller so its wiring stays
 * in one place. Extracted verbatim from TestSessionView.
 */
export function SessionHeader({
  isMobile,
  backToLabel,
  sessionMobileTitle,
  siteId,
  siteDisplayName,
  jobStarted,
  optionsMenu,
  onBack,
}) {
  if (isMobile) {
    return (
      <header className="session-mobile-header" aria-label="Session navigation">
        <button
          type="button"
          className="session-mobile-header-back"
          onClick={onBack}
          aria-label={backToLabel}
          title={backToLabel}
        >
          <FiChevronLeft size={24} aria-hidden />
        </button>
        <h1 className="session-mobile-header-title">{sessionMobileTitle}</h1>
        {optionsMenu}
      </header>
    );
  }

  return (
    <div className="session-breadcrumb-row">
      <nav className="breadcrumb" aria-label="Breadcrumb">
        <Link to="/sites" className="breadcrumb-link">Sites</Link>
        <span className="breadcrumb-sep" aria-hidden>›</span>
        <span className="breadcrumb-current">
          {siteId ? siteDisplayName : jobStarted ? 'Select site' : 'Start session'}
        </span>
        <span className="breadcrumb-sep" aria-hidden>›</span>
        <span className="breadcrumb-current">Test</span>
      </nav>
      {optionsMenu}
    </div>
  );
}
